module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/business-light.module.scss");